<template>
  <div>
    <v-btn outlined class="grey--text lighten-3" :href="`/start/github?redirectTo=${redirectTo}`">
      <v-icon class="mr-2">
        mdi-github
      </v-icon>
      GitHub
    </v-btn>
  </div>
</template>

<style lang="stylus">
  .oauth
    &:hover
      > svg
        fill: #2979ff

</style>

<script>

export default {
  computed: {
    redirectTo() {
      if (this.$route.query.redirectTo) {
        return this.$route.query.redirectTo
      }

      // Possible that we got redirected here from a different
      // page
      let redirect = this.$auth.redirect();

      if (redirect && redirect.from) {
        return redirect.from.path
      }

      return '/'
    }
  }
}

</script>